import { Component } from '@angular/core';

@Component({
  selector: 'app-common-export',
  templateUrl: './common-export.component.html',
  styleUrl: './common-export.component.scss'
})
export class CommonExportComponent {

}
